import ajax from '../../lib/ajax'

// QuerySysDic
// 字典类型查询
export async function QuerySysDic(payload:any) {
    let res = await ajax.post('api/services/app/Materials/QuerySysDic', payload,false)
    return res.data.result
}
// QueryCreateSysDic
// 新增字典类型
export async function QueryCreateSysDic(payload:any) {
    let res = await ajax.post('api/services/app/Materials/QueryCreateSysDic', payload)
    return res.data.result
}
// QueryEditSysDic
// 编辑字典类型
export async function QueryEditSysDic(payload:any) {
    let res = await ajax.post('api/services/app/Materials/QueryEditSysDic', payload)
    return res.data.result
}
// QueryDeleteSysDic
// 删除字典类型
export async function QueryDeleteSysDic(payload:any) {
    let res = await ajax.post('api/services/app/Materials/QueryDeleteSysDic', payload)
    return res.data.result
}
// QueryMaterials
// 物资查询
export async function QueryMaterials(payload:any) {
    let res = await ajax.post('api/services/app/Materials/QueryMaterials', payload,false)
    return res.data.result
}
// QueryMaterialsCreate
// 物资新增
export async function QueryMaterialsCreate(payload:any) {
    let res = await ajax.post('api/services/app/Materials/QueryMaterialsCreate', payload)
    return res.data.result
}
// QueryMaterialsEdit
// 物资编辑
export async function QueryMaterialsEdit(payload:any) {
    let res = await ajax.post('api/services/app/Materials/QueryMaterialsEdit', payload)
    return res.data.result
}
// QueryMaterialSyn
// 物资同步
export async function QueryMaterialSyn(payload:any) {
    let res = await ajax.post('api/services/app/Materials/QueryMaterialSyn', payload)
    return res.data.result
}
export async function GetMaterialsSynStatusById(payload:any) {
    let res = await ajax.get('api/services/app/Materials/GetMaterialsSynStatusById', {params:payload})
    return res.data.result
}
export async function SynMaterialsToTenants(payload:any) {
    let res = await ajax.post('api/services/app/Materials/SynMaterialsToTenants', payload)
    return res.data.result
}
export async function SynManufacturerToTenants(payload:any) {
    let res = await ajax.post('api/services/app/BasicData/SynManufacturerToTenants', payload)
    return res.data.result
}